import './styles/carousel.scss';